/** Types for `GET /api/v3/deal-pulse/customers/{gcid}/trade-in-intelligence?dealId=…`. */

/** Bounded outcome codes — safe to facet on in New Relic. */
export enum TradeInIntelligenceProxyOutcome {
    ACCEPTED = 'accepted',
    NO_CUSTOMER_IDENTIFIER = 'no_customer_identifier',
    NO_DEAL_IDENTIFIER = 'no_deal_identifier',
    DOWNSTREAM_FAILURE = 'downstream_failure',
    /** The service declined with a 204, so no push will arrive. */
    DOWNSTREAM_REFUSED = 'downstream_refused',
    DOWNSTREAM_TIMEOUT = 'downstream_timeout'
}

/** Carries an outcome only — the valuations arrive as a live push on `dealPulseTradeIn`. */
export type TradeInIntelligenceAcknowledgementBffData = {
    ok: boolean;
    outcome: TradeInIntelligenceProxyOutcome;
    correlationId: string;
};
